import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';

const RETAIL_ONLY_ROLES = ['Receptionist', 'Pharmacist'];

/**
 * True if the current user has vendor/procurement access (Purchase Orders, GRN, Vendor Ledger, etc.).
 * Requires the pharmacy itself to be a vendor (isVendor). Retail-only roles (Receptionist, Pharmacist)
 * need the explicit `vendor` permission on top of that.
 */
export function useCanSeeVendor(): boolean {
  const { user } = useAuth();
  return useMemo(() => {
    const role = user?.role ?? '';
    if (user?.isVendor !== true) return false;
    if (role === 'Pharmacist' && user?.pharmacyPermissions?.includes('vendor')) {
      return true;
    }
    return !RETAIL_ONLY_ROLES.includes(role);
  }, [user?.isVendor, user?.role, user?.pharmacyPermissions]);
}
